<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>短途运输完成明细使用说明:<br>
					<span>1、单号构成规则:201201+DTYS+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交后开始结算。</span><br>
					<span class="red">3、费用明细=现金上交，则为收入类型，指上一单剩余现金本次上交公司情景。</span><br>
					<span>4、查询关键字:单号、车牌、开始日期、截至日期、装货点、客户姓名、司机、状态。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="pre_base_button">
				<button class="pre_btn_ok" @click="edit_mode('pass_sel')">费用结算</button>
			</template>
			<template slot="pre_tan_button">
				<button class="pre_btn_ok" @click="edit_mode('wz')">违章信息</button>
			</template>
			<template slot="pre_tan_button">
				<button class="pre_btn_ok" @click="edit_mode('wx')">维修信息</button>
			</template> -->
		</pre-base>
		<!-- <carwx ref="carwx"></carwx>
		<carwz ref="carwz"></carwz> -->
		<!-- <carover ref="carover"></carover> -->
	</div>
</template>

<script>
	import {
		GetShort
	} from '@/utils/localstore.js';

	import api from '@/utils/type.js';
	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_v2.vue"),
			// 'carwx': () => import("./tan_car_wx.vue"),
			// 'carwz': () => import("./tan_car_wz.vue"),
			// 'carover': () => import("./tan_car_over.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "trans_d_over",
					"title": "短途运输登记",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"isShowEdit": "0",
					"step": "0",
					"sel_action": 'exp_dtys_trans_short_d_over',
					"upd_action": '',
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": 'ys',
					"p2": 'dt',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "截至日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "装货地点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "客户姓名",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"sel": "6"
						},
						{
							"name": "司机姓名",
							"val": "",
							"key": "driver",
							"type": "text",
							"class": "long1",
							"sel": "7"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_dt_pay",
							"sel_name": "",
							"sel": "8"
						}
					],
					"parm": [],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "客户"
						},
						{
							"name": "日期"
						},
						{
							"name": "起点"
						},
						{
							"name": "终点"
						},
						{
							"name": "车牌"
						},
						{
							"name": "司机"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						{
							"name": "卡号"
						},
						{
							"name": "支付日期"
						},
						{
							"name": "支付|收入"
						},
						// {
						// 	"name": "是否开票"
						// },
						// {
						// 	"name": "公司已支付"
						// },
						{
							"name": "备注",
							"class": "long2"
						},
						// {
						// 	"name": "附件"
						// },

						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "更新时间",
							"class": "long2"
						},
						{
							"name": "附件"
						}
					],
					"d_parm": [],
					"d_name": []

				});


			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: async function(type) {
				let sheet_no = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'sheet_no') {
						sheet_no = this.item[i].val;
					}
				}
				let res, o = {};
				o.sheet_no = sheet_no;

				let that = this;
				switch (type) {
					case 'wx':
						// 弹出修改明细，修改主窗口信息
						res = await this.Is_exists_something('car_is_Exists_wx', sheet_no)
						// this.refresh_data();
						// console.log(res);
						if (res.status == '0') {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							return;
						}
						this.$nextTick(function() {
							that.$refs['carwx'].showpop(o);
						});
						break;
					case 'wz':
						// 弹出修改明细，修改主窗口信息
						res = await this.Is_exists_something('car_is_Exists_wz', sheet_no)
						// this.refresh_data();
						// console.log(res);
						if (res.status == '0') {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							return;
						}
						this.$nextTick(function() {
							that.$refs['carwz'].showpop(o);
						});
						break;
					case 'pass_sel':
						this.$nextTick(function() {
							that.$refs['carover'].showpop();
						});
						break;
					default:
						this.$message({
							message: '单号=' + sheet_no + '编辑失败!操作=' + type + ' 未配置!',
							type: 'success'
						});
						break;
				}
			},
			Is_exists_something: function(action, temp_no) {
				let that = this;
				let d = [];
				d.push(temp_no);
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_Common(action, 0, '', d)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			}







		}
	};
</script>
<style>
</style>